import "./globals.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./auth";
import Sidebar       from "./components/Sidebar";
import Login         from "./pages/Login";
import Kiosk         from "./pages/Kiosk";
import CheckIn       from "./pages/CheckIn";
import Attendance    from "./pages/Attendance";
import History       from "./pages/History";
import Leaves        from "./pages/Leaves";
import Timesheet     from "./pages/Timesheet";
import DirectCall    from "./pages/DirectCall";
import Team          from "./pages/Team";
import Admin         from "./pages/Admin";
import LeaveAdmin    from "./pages/LeaveAdmin";
import Reports       from "./pages/Reports";
import Salary        from "./pages/Salary";
import Profile       from "./pages/Profile";
import SuperAdminApp from "./pages/SuperAdminApp";
import CompanyLogin  from "./pages/CompanyLogin";

function Portal({ loginPath }) {
  const { me, loading } = useAuth();
  if (loading) return null;
  if (!me) return <Navigate to={loginPath} replace/>;
  // Derive basePath from loginPath: /bd/login → /bd/portal
  const basePath = loginPath.replace("/login", "/portal");
  return (
    <div className="app">
      <Sidebar basePath={basePath}/>
      <main className="main">
        <Routes>
          <Route path="checkin"     element={<CheckIn/>}/>
          <Route path="attendance"  element={<Attendance/>}/>
          <Route path="history"     element={<History/>}/>
          <Route path="leaves"      element={<Leaves/>}/>
          <Route path="timesheet"   element={<Timesheet/>}/>
          <Route path="direct_call" element={<DirectCall/>}/>
          <Route path="team"        element={<Team/>}/>
          <Route path="admin"       element={<Admin/>}/>
          <Route path="leave_admin" element={<LeaveAdmin/>}/>
          <Route path="reports"     element={<Reports/>}/>
          <Route path="salary"      element={<Salary/>}/>
          <Route path="profile"     element={<Profile/>}/>
          <Route path="*"           element={<Navigate to="checkin" replace/>}/>
        </Routes>
      </main>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/kiosk"        element={<Kiosk company={null}/>}/>
          <Route path="/iws/kiosk"    element={<Kiosk company="IWS"/>}/>
          <Route path="/bd/kiosk"     element={<Kiosk company="BD"/>}/>
          <Route path="/superadmin/*" element={<SuperAdminApp/>}/>
          <Route path="/iws/login"    element={<CompanyLogin/>}/>
          <Route path="/bd/login"     element={<CompanyLogin/>}/>
          <Route path="/iws/portal/*" element={<Portal loginPath="/iws/login"/>}/>
          <Route path="/bd/portal/*"  element={<Portal loginPath="/bd/login"/>}/>
          <Route path="/portal/login" element={<Login/>}/>
          <Route path="/portal/*"     element={<Portal loginPath="/portal/login"/>}/>
          <Route path="/"             element={<Navigate to="/portal/login" replace/>}/>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
